import DialogCamera from './DialogCamera';

export default DialogCamera;